import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../mp-core/themes/palette"
import { tooltipClasses } from "@mui/material"

export const useStyles = makeStyles()(({ spacing }) => ({
  card: {
    position: "sticky",
    zIndex: 100,
    top: `calc(64px + ${spacing(2)})`
  },
  cardHeader: {
    paddingBottom: spacing(2)
  },
  cardContent: {
    paddingTop: 0,
    "&:last-of-type": {
      paddingBottom: spacing(2)
    }
  },
  divider: {
    borderColor: blueGrey[100],
    margin: spacing(2, 0)
  },
  list: {
    padding: 0
  },
  tooltip: {
    maxWidth: "160px",
    bottom: spacing(5)
  }
}))
